import React, { useContext } from 'react';
import './games-container.scss';
import { StateContext } from '../../contexts/state';
import GameThumbnail from '../game-thumbnail/game-thumbnail';
import LazyLoad, { forceCheck } from 'react-lazyload';
import Carousel from '../carousel/carousel';

const GamesContainer = ({ onGameClick, games }) => {
	const dataContext = useContext(StateContext);
	const mapCategory = (category, className = '', showMask = false) => {
		let filteredGames = extractGames(games, category);
		return (
			(!!filteredGames?.length) && (
				<Carousel showArray={true}>
					<div className="games-container__category" key={category}>
						<span
							className={`games-container__category__title ${
								category === 'Favorites' ? 'games-container__category__title--favorites' : ''
							}`}
						>
							{category}
						</span>
						<div className="games-container__category__games">
							{filteredGames.map((game, index) => mapGame(game, index, category === 'Favorites'))}
						</div>
					</div>
				</Carousel>
			)
		);
	};

	const mapGame = (game, index, deleteFav) => {
		return (
			<GameThumbnail
				key={index}
				onClick={() => onGameClick(game)}
				category={game.categories[0]}
				id={game.id}
				title={game.name}
				rating={Number((game.rating / 20).toFixed(1))}
				icon={game.images.screenshot_1}
				sIcon={game.images.image_1}
				deleteFav={deleteFav}
			/>
		);
	};

	function extractGames(data, category) {
		if (!data) return;

		return data.filter(game => (game.categories.indexOf(category) === -1 ? false : true));
	}
	//		setGames(extractGames(dataContext.data?.data?.content));
	return (
		<div
			className="games-container"
			onScroll={() => {
				forceCheck();
			}}
		>
			{/* To GamesList component:  */}
			{(!!dataContext.data?.favorites?.length) && mapCategory('Favorites')}
			{dataContext.data.categories.map((category, index) => {
				if (index > 1) {
					return <LazyLoad height={140} offset={100}>
						{mapCategory(category)}
					</LazyLoad>
				} else {
					return mapCategory(category);
				}
			})}
		</div>
	);
};

export default GamesContainer;
